import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import {
  createSingleLead,
  getChannelsAndProjects,
} from "../../network/api/leads";

const AddSingleLeadPage = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [channelsAndProjects, setChannelsAndProjects] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    info: "",
    mobile: "",
    project: "",
    channel: "",
    destination: "",
  });

  useEffect(() => {
    getChannelsAndProjects().then((result) => {
      setChannelsAndProjects(result.data);
    });
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    createSingleLead(formData).then((result) => {
      if (result.data.message === "Created successfully") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        props.changeToViewAddLead();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
      setLoading(false);
    });
  };

  return (
    <>
      {!channelsAndProjects ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="Name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Name"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Name is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="info">User Info</label>
              <input
                type="text"
                id="info"
                name="info"
                value={formData.info}
                onChange={handleChange}
                placeholder="Enter User Info"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("User Info is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="mobile">User Phone</label>
              <input
                type="text"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter User Phone"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("User Phone is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="destination">User Destination</label>
              <input
                type="text"
                id="destination"
                name="destination"
                value={formData.destination}
                onChange={handleChange}
                placeholder="Enter User Destination"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("User Destination is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="region">Project</label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Project"
                name="project" // Changed from type2 to be more descriptive
                value={formData.project}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    project: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Project is required")
                }
              >
                <option disabled value="">
                  Select Project
                </option>
                {channelsAndProjects.projects?.map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="channel">Channel</label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Channel"
                name="channel" // Changed from type2 to be more descriptive
                value={formData.channel}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    channel: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) => e.target.setCustomValidity("Channel")}
              >
                <option disabled value="">
                  Select Channel
                </option>
                {channelsAndProjects.channels?.map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add Single Lead
              </button>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </>
  );
};

export default AddSingleLeadPage;
